import { render, staticRenderFns } from "./DownloadNotices.vue?vue&type=template&id=18fb6d6c&scoped=true"
import script from "./DownloadNotices.vue?vue&type=script&lang=js"
export * from "./DownloadNotices.vue?vue&type=script&lang=js"
import style0 from "./DownloadNotices.vue?vue&type=style&index=0&id=18fb6d6c&prod&lang=scss&scoped=true"
import style1 from "./DownloadNotices.vue?vue&type=style&index=1&id=18fb6d6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fb6d6c",
  null
  
)

export default component.exports